export function isParsable(input) {
  const parsed = parseFloat(input);
  return !Number.isNaN(parsed);
}